import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./LegalDocumentPage.scss";

// Renderiza um documento legal estruturado como { title, sections: [{ level, heading, paragraphs }] }
export default function LegalDocumentPage({ content }) {
  return (
    <div className="legal-page">
      <div className="legal-page__card">
        <Link to="/" className="legal-page__back">
          <ArrowLeft size={16} />
          Voltar
        </Link>

        <h1 className="legal-page__title">{content.title}</h1>
        <p className="legal-page__updated">
          Última atualização: {content.lastUpdated}
        </p>

        {content.sections.map((section, idx) => {
          const HeadingTag = section.level === 3 ? "h3" : "h2";
          return (
            <section key={idx} className={`legal-page__section legal-page__section--level-${section.level}`}>
              <HeadingTag className="legal-page__heading">{section.heading}</HeadingTag>
              {section.paragraphs.map((p, pIdx) => (
                <p key={pIdx} className="legal-page__paragraph">{p}</p>
              ))}
            </section>
          );
        })}
      </div>
    </div>
  );
}